/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateEmployeeRoleRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateEmployeeRoleResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateEmployeeRole = (request: UpdateEmployeeRoleRequest, options?: CashRequestOptions) => post<UpdateEmployeeRoleRequest, UpdateEmployeeRoleResponse>("/2.0/cash/update-employee-role", request, {...options, rejectOnError: true })